import React from "react";
import { XLg } from 'react-bootstrap-icons';
import Button from 'react-bootstrap/Button';

export default (params) => {
  return (
    <div>
      <Button variant="outline-danger" size="sm" onClick={params.onClick}><XLg /></Button>
    </div>
  )
}